/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JumboStructsEDRIntuneDeploymentCount } from './JumboStructsEDRIntuneDeploymentCount';
import {
    JumboStructsEDRIntuneDeploymentCountFromJSON,
    JumboStructsEDRIntuneDeploymentCountFromJSONTyped,
    JumboStructsEDRIntuneDeploymentCountToJSON,
} from './JumboStructsEDRIntuneDeploymentCount';
import type { JumboStructsEDRMachineCriticalIssuesCount } from './JumboStructsEDRMachineCriticalIssuesCount';
import {
    JumboStructsEDRMachineCriticalIssuesCountFromJSON,
    JumboStructsEDRMachineCriticalIssuesCountFromJSONTyped,
    JumboStructsEDRMachineCriticalIssuesCountToJSON,
} from './JumboStructsEDRMachineCriticalIssuesCount';
import type { JumboStructsEDRMachineMetricsLicenseCount } from './JumboStructsEDRMachineMetricsLicenseCount';
import {
    JumboStructsEDRMachineMetricsLicenseCountFromJSON,
    JumboStructsEDRMachineMetricsLicenseCountFromJSONTyped,
    JumboStructsEDRMachineMetricsLicenseCountToJSON,
} from './JumboStructsEDRMachineMetricsLicenseCount';
import type { JumboStructsEDRMachineOSCount } from './JumboStructsEDRMachineOSCount';
import {
    JumboStructsEDRMachineOSCountFromJSON,
    JumboStructsEDRMachineOSCountFromJSONTyped,
    JumboStructsEDRMachineOSCountToJSON,
} from './JumboStructsEDRMachineOSCount';
import type { JumboStructsEDRMachineSettingsCount } from './JumboStructsEDRMachineSettingsCount';
import {
    JumboStructsEDRMachineSettingsCountFromJSON,
    JumboStructsEDRMachineSettingsCountFromJSONTyped,
    JumboStructsEDRMachineSettingsCountToJSON,
} from './JumboStructsEDRMachineSettingsCount';

/**
 * 
 * @export
 * @interface JumboStructsEDRMachineMetricsResult
 */
export interface JumboStructsEDRMachineMetricsResult {
    /**
     * 
     * @type {JumboStructsEDRMachineCriticalIssuesCount}
     * @memberof JumboStructsEDRMachineMetricsResult
     */
    criticalIssuesBreakdown?: JumboStructsEDRMachineCriticalIssuesCount;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRMachineMetricsResult
     */
    endpointIntegrationCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRMachineMetricsResult
     */
    firewallDisabledEndpointCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRMachineMetricsResult
     */
    infectedEndpointCount?: number;
    /**
     * 
     * @type {JumboStructsEDRIntuneDeploymentCount}
     * @memberof JumboStructsEDRMachineMetricsResult
     */
    intuneDeploymentBreakdown?: JumboStructsEDRIntuneDeploymentCount;
    /**
     * 
     * @type {Array<JumboStructsEDRMachineMetricsLicenseCount>}
     * @memberof JumboStructsEDRMachineMetricsResult
     */
    licenseBreakdown?: Array<JumboStructsEDRMachineMetricsLicenseCount>;
    /**
     * 
     * @type {boolean}
     * @memberof JumboStructsEDRMachineMetricsResult
     */
    mdeConnectorEnabled?: boolean;
    /**
     * 
     * @type {Array<JumboStructsEDRMachineOSCount>}
     * @memberof JumboStructsEDRMachineMetricsResult
     */
    osBreakdown?: Array<JumboStructsEDRMachineOSCount>;
    /**
     * 
     * @type {JumboStructsEDRMachineSettingsCount}
     * @memberof JumboStructsEDRMachineMetricsResult
     */
    settingsBreakdown?: JumboStructsEDRMachineSettingsCount;
}

/**
 * Check if a given object implements the JumboStructsEDRMachineMetricsResult interface.
 */
export function instanceOfJumboStructsEDRMachineMetricsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsEDRMachineMetricsResultFromJSON(json: any): JumboStructsEDRMachineMetricsResult {
    return JumboStructsEDRMachineMetricsResultFromJSONTyped(json, false);
}

export function JumboStructsEDRMachineMetricsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsEDRMachineMetricsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criticalIssuesBreakdown': !exists(json, 'criticalIssuesBreakdown') ? undefined : JumboStructsEDRMachineCriticalIssuesCountFromJSON(json['criticalIssuesBreakdown']),
        'endpointIntegrationCount': !exists(json, 'endpointIntegrationCount') ? undefined : json['endpointIntegrationCount'],
        'firewallDisabledEndpointCount': !exists(json, 'firewallDisabledEndpointCount') ? undefined : json['firewallDisabledEndpointCount'],
        'infectedEndpointCount': !exists(json, 'infectedEndpointCount') ? undefined : json['infectedEndpointCount'],
        'intuneDeploymentBreakdown': !exists(json, 'intuneDeploymentBreakdown') ? undefined : JumboStructsEDRIntuneDeploymentCountFromJSON(json['intuneDeploymentBreakdown']),
        'licenseBreakdown': !exists(json, 'licenseBreakdown') ? undefined : ((json['licenseBreakdown'] as Array<any>).map(JumboStructsEDRMachineMetricsLicenseCountFromJSON)),
        'mdeConnectorEnabled': !exists(json, 'mdeConnectorEnabled') ? undefined : json['mdeConnectorEnabled'],
        'osBreakdown': !exists(json, 'osBreakdown') ? undefined : ((json['osBreakdown'] as Array<any>).map(JumboStructsEDRMachineOSCountFromJSON)),
        'settingsBreakdown': !exists(json, 'settingsBreakdown') ? undefined : JumboStructsEDRMachineSettingsCountFromJSON(json['settingsBreakdown']),
    };
}

export function JumboStructsEDRMachineMetricsResultToJSON(value?: JumboStructsEDRMachineMetricsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criticalIssuesBreakdown': JumboStructsEDRMachineCriticalIssuesCountToJSON(value.criticalIssuesBreakdown),
        'endpointIntegrationCount': value.endpointIntegrationCount,
        'firewallDisabledEndpointCount': value.firewallDisabledEndpointCount,
        'infectedEndpointCount': value.infectedEndpointCount,
        'intuneDeploymentBreakdown': JumboStructsEDRIntuneDeploymentCountToJSON(value.intuneDeploymentBreakdown),
        'licenseBreakdown': value.licenseBreakdown === undefined ? undefined : ((value.licenseBreakdown as Array<any>).map(JumboStructsEDRMachineMetricsLicenseCountToJSON)),
        'mdeConnectorEnabled': value.mdeConnectorEnabled,
        'osBreakdown': value.osBreakdown === undefined ? undefined : ((value.osBreakdown as Array<any>).map(JumboStructsEDRMachineOSCountToJSON)),
        'settingsBreakdown': JumboStructsEDRMachineSettingsCountToJSON(value.settingsBreakdown),
    };
}

